import { RouteEntry } from "../../shared/routes";
import { StripeExcessContainer } from "./ExcessPayment";
import { StripeExcessCompleteContainer } from "./ExcessPaymentComplete";

export const excessPaymentRoutes: Array<RouteEntry> = [
    { path: '/excess-payment/:id', component: StripeExcessContainer },
    { path: '/excess-payment-completed/:id', component: StripeExcessCompleteContainer },
];
